import { useTranslation as e } from "../../i18n.mjs";
import { toolbarActionItem as t } from "../../components/content-controls/toolbar-action-item.mjs";
import { getShortcut as n, rawShortcuts as r } from "../../utils/get-shortcuts.mjs";
import { useEditorState as i } from "@tiptap/react";
import { useMemo as a } from "react";
import { jsx as o } from "react/jsx-runtime";
import { ArrowLeftIcon as s, ArrowRightIcon as c } from "@systemeio/icons";
//#region src/extensions/history-extension/use-history-extension-toolbar.tsx
var l = (l) => {
	let { t: u } = e(), d = i({
		editor: l,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			canUndo: e?.can().undo() ?? !1,
			canRedo: e?.can().redo() ?? !1
		})
	}), f = !d?.isEditable || !d?.canUndo, p = !d?.isEditable || !d?.canRedo;
	return a(() => {
		let e = {
			Icon: s,
			disabled: f,
			label: u("undo"),
			onClick: () => l?.chain().focus().undo().run(),
			shortcut: n(r.history.undo)
		}, i = {
			Icon: c,
			disabled: p,
			label: u("redo"),
			onClick: () => l?.chain().focus().redo().run(),
			shortcut: n(r.history.redo)
		}, a = ({ Icon: e, disabled: n, label: r, onClick: i, shortcut: a }) => t({
			disabled: n,
			icon: /* @__PURE__ */ o(e, {}),
			label: r,
			onClick: i,
			tooltip: `${r} (${a})`
		});
		return [a(e), a(i)];
	}, [
		l,
		p,
		f,
		u
	]);
};
//#endregion
export { l as useHistoryExtensionToolbar };
